import React, { useState, useEffect, useRef, Suspense, useContext } from "react";
import InstallationGuide from "../InstallationGuide/InstallationGuide";
import { fetchTopUpPackages } from "../../../services/TopUpService";
import TopUpPackagesSection from "../../Esim/TopUpPackagesSection/TopUpPackagesSection";
import { AuthContext } from "../../../context/AuthContext";
import EsimActions from "../EsimActions/EsimActions";
import "./EsimActionsSection.css";

const EsimActionsSection = ({ selectedEsim }) => {
  const { token, walletCurrency } = useContext(AuthContext);
  const currency = token ? walletCurrency : "EUR";
  const [deviceType, setDeviceType] = useState("IOS");
  const [showTopUp, setShowTopUp] = useState(false);
  const [hasTopUpPackages, setHasTopUpPackages] = useState(false);

  const topUpRef = useRef(null);

  useEffect(() => setShowTopUp(false), [selectedEsim]);

  useEffect(() => {
    setShowTopUp(false);
    setHasTopUpPackages(false);

    if (!selectedEsim?.iccid) return;

    fetchTopUpPackages({ iccid: selectedEsim.iccid, currency })
      .then((packages) => {
        setHasTopUpPackages(packages.length > 0);
      })
      .catch(() => setHasTopUpPackages(false));
  }, [selectedEsim, currency]);

  useEffect(() => {
    if (showTopUp && topUpRef.current) {
      setTimeout(() => {
        topUpRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, [showTopUp]);

  return (
    <div className="esim-actions-wrapper">
      <div className="esim-actions-section">
        <InstallationGuide selectedEsim={selectedEsim} deviceType={deviceType} setDeviceType={setDeviceType} />
        <EsimActions
          selectedEsim={selectedEsim}
          deviceType={deviceType}
          onToggleTopUp={() => setShowTopUp((prev) => !prev)}
          isTopUpOpen={showTopUp}
          hasTopUpPackages={hasTopUpPackages}
        />
      </div>

      {showTopUp && selectedEsim && (
        <Suspense fallback={<div className="loading-text">Loading top-up section...</div>}>
          <div ref={topUpRef} style={{ width: "100%" }}>
            <TopUpPackagesSection iccid={selectedEsim.iccid} esimDetails={selectedEsim} />
          </div>
        </Suspense>
      )}
    </div>
  );
};

export default EsimActionsSection;
